import { useSetAtom, atom } from 'jotai';
import { Classroom } from '@teetsh/app/src/types/classroom';

export const creatorEventPayload = atom<
  | {
      id: string; // the id needs to be stable because it is used as a key, so we define it when opening the modal
      start: Date;
      classrooms: Classroom[];
      end: Date;
    }
  | undefined
>(undefined);

export const useOpenCreateEDTSeance = () => useSetAtom(creatorEventPayload);
